<modal :confirm-options="confirmOptions" :selector-close="selectorClose"></modal>